export enum AplicacaoEnum {
  EXTRA = 'Extrajudicial',
  JUDICIAL = 'Judicial',
  POLICIAL = 'Policial',
  FISICO = 'Fisico',
  PETICAO_INICIAL = 'Petição Inicial'
}
